import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import dmax from "../../../../assets/info/d-max-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const IsuzuDMax = () => {
  useSmallNav("Isuzu D-Max");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Isuzu D-Max"} bolder />
        <InfoHero image={dmax} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Do you own and drive a Isuzu D-max? Looking for suspension parts or suspension upgrades?"
              }
            />
            <InfoHeader
              size="smaller"
              text={"Then you have come to the right place."}
            />
            <p>
              Here at Pedders Suspension we offer a wide range of suspension
              parts including numerous upgraded parts to suit all manner of
              uses.
            </p>
            <p>
              For those carrying heavy loads or towing on a regular basis, we
              are able to offer upgraded rear springs and shocks to cope better
              with the demands of such use. With upto 3 different rear leaf
              spring combinations, (dependant on model) we will have something
              to suit. For those operating at the limit of the vehicles
              abilities, these can be supplemented with an air bag system.
              Whatever your usage, we will have a combination of parts to do the
              job.
            </p>
            <p>
              Popular amongst our upgrades are lift kits, be it for serious
              off-roading or just for a more aggressive look, again, we have the
              parts you need. Multiple shock options allow the vehicle to be
              tailored to your usuage.
            </p>
            <p>
              Looked at our list of Kits and parts, but still not sure what you
              require? Then please get in touch where one of our team will be
              able to assist you.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/V9VVX_krAbw"
              title={"Isuzu D-Max Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/5olMu1M-eJ8"
              title={"Isuzu D-Max Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              title={"Isuzu D-Max Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/1VOpGb50izY"
              title={"Isuzu D-Max Video 4"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Isuzu D-Max Video 5"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Isuzu")
              .models.find((e) => e.display === "D-Max")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        <InfoFooter make="Isuzu" model="D-Max" />
      </Container>
    </section>
  );
};

export default IsuzuDMax;
